<template>
  <v-container id="genericReport" fluid style="overflow: auto">
    <header
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      "
    >
      <div
        style="
          border-bottom: 1px solid #aaa;
          width: 100%;
          text-align: center;
          margin-bottom: 10px;
        "
      >
        <Footer />
      </div>
      <img
        :src="
          prefecture.prefecture_logo
            ? 'https://api.sigfrotagov.com.br/uploads/' + prefecture.prefecture_logo?.replace('https://api.sigfrotagov.com.br/uploads/', '')
            : require('@/assets/no-image.jpg')
        "
        :alt="prefecture.social_name ? prefecture.social_name : ''"
        style="width: 250px; padding: 20px"
      />
      <h1 style="font-weight: 400" class="mt-5">
        {{
          prefecture.prefecture_social_name
            ? prefecture.prefecture_social_name
            : ""
        }}
      </h1>
      <h2 style="margin-top: 50px">RELATÓRIO DE ALMOXARIFADO</h2>
      <h4>
        Período de: {{ convertDate(filter.startDate) }} até
        {{ convertDate(filter.endDate) }}
      </h4>
    </header>
    <br />
    <br />

    <table
      class="table"
      style="
        border-collapse: collapse;
        border: 1px solid rgb(214, 214, 214);
        border-top: 0;
        text-align: center;
        width: 100%;
        font-size: 12px;
        margin-top: 50px;
      "
    >
      <thead>
        <tr style="border: 1px solid rgb(214, 214, 214); text-align: center">
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 3px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            NOTA FISCAL
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 3px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            LICITADO
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 3px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            QTD.
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 3px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            FORNECEDOR
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 3px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            SAÍDA
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 3px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            QTD. SAÍDA
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 3px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            MOVIMENTAÇÃO
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 3px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            VEÍCULO
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 3px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            DATA DA MOVIMENTAÇÃO
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 3px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            ESTOQUE
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 3px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            QTD. ESTOQUE
          </th>
        </tr>
      </thead>
      <tbody v-for="(value, index) in data" :key="index">
        <tr v-for="(item, i) in value.nf_item" :key="i">
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ value.nf_number }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{
              item.isServico
                ? item.servico
                : `${item.details[0].name} (${item.details[0].origem})`
            }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ item.isServico ? "1" : item.details[0].quantidade }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ value.provider_name }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{
              item.isServico
                ? item.servico
                : `${item.details[0].name} (${item.details[0].origem})`
            }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ item.isServico ? "1" : item.quantidade }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ `${value.sec_name} ↔ ${value.sec_name_recipient}` }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ value.brand_desc ? `${value.brand_desc} - ${value.model_desc} - ${value.vehicle_board}` : '' }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ convertDate(value.nf_issue_date) }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{
              item.isServico
                ? item.servico
                : `${item.details[0].name} (${item.details[0].origem})`
            }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ item.isServico ? "0" : item.restante }}
          </td>
        </tr>
      </tbody>
    </table>
  </v-container>
</template>

<script>
import Footer from "@/components/Footer.vue";
import helpers from "@/mixins/helpers";
export default {
  components: {
    Footer,
  },
  props: ["data", "filter", "prefecture"],
  mixins: [helpers],
  mounted: {},
  methods: {
    initialize() {
      this.helpers;
    },
  },
};
</script>

<style scoped>
table {
  border-collapse: collapse;
  border: 1px solid rgb(17, 17, 17);
}
</style>
